import { useEffect, useState } from "preact/hooks";
import fetchDesigners from "./fetchDesigners";

export default function useDesigners() {
  const [designers, setDesigners] = useState([]);

  useEffect(() => {
    fetchDesigners().then(data => setDesigners(data));
  }, []);

  return [designers];
};
